var map = {
	"./aem.svg": "23bb",
	"./bitrix.svg": "3515",
	"./c++.svg": "ec8c",
	"./confluence.svg": "2439",
	"./css.svg": "8ce4",
	"./docker.svg": "414a",
	"./email.svg": "195b",
	"./fb.svg": "4f33",
	"./figma.svg": "792a",
	"./filezilla.svg": "c36f",
	"./gimp.svg": "afea",
	"./git.svg": "6078",
	"./gulp.svg": "f251",
	"./html.svg": "378a",
	"./hybris.svg": "79bf",
	"./illustrator.svg": "d53b",
	"./indesign.svg": "284f",
	"./inst.svg": "5dfa",
	"./jira.svg": "acc4",
	"./joomla.svg": "6e20",
	"./jquery.svg": "352f",
	"./js.svg": "9c00",
	"./less.svg": "eb8a",
	"./linked.svg": "0dd7",
	"./linux.svg": "2157",
	"./loading.svg": "96a0",
	"./logo.svg": "e9c6",
	"./logo_2.svg": "daf3",
	"./logo_3.svg": "56ee",
	"./logo_3_black.svg": "811b",
	"./logo_4.svg": "d0f5",
	"./logo_4_white.svg": "5f25",
	"./logo_5.svg": "e78b",
	"./logo_5s.svg": "ff79",
	"./macos.svg": "60c5",
	"./mysql.svg": "e6ff",
	"./netpeak-spider.svg": "761b",
	"./nuxt.svg": "5d9c",
	"./opencart.svg": "1705",
	"./oracle.svg": "b61d",
	"./phone.svg": "f012",
	"./photoshop.svg": "2262",
	"./php.svg": "532b",
	"./process_1.svg": "8281",
	"./process_2.svg": "d7c3",
	"./process_3.svg": "5f0b",
	"./process_4.svg": "4643",
	"./process_5.svg": "2218",
	"./process_6.svg": "e1fc",
	"./python.svg": "7b0a",
	"./react.svg": "7fa7",
	"./sass.svg": "b1f8",
	"./skype.svg": "297f",
	"./snow.svg": "1976",
	"./telegram.svg": "2abb",
	"./vue.svg": "54f8",
	"./wordpress.svg": "f997",
	"./xd.svg": "00eb",
	"./yext.svg": "9363"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9959";